import React, { Component } from 'react';
import { BlankTemplate } from '../BlankTemplate';
import { Link } from 'react-router-dom'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faBinoculars, faHome} from '@fortawesome/fontawesome-free-solid';
import './page404.scss';

export class Page404 extends Component {
    render() {
        return (
            <BlankTemplate>
                <div id="page404">
                    <div className="iconImg">
                        <FontAwesomeIcon icon={faBinoculars}/>
                    </div>
                    <div className="soryText">
                        אופס...
                        הדף שחיפשת לא נמצא! <br /><br />
                        <Link to="/">
                            <FontAwesomeIcon icon={faHome}/> קח אותי הביתה
                        </Link>
                    </div>
                </div>
            </BlankTemplate>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Page404/Page404.jsx